import { matchPath } from "react-router-dom";

/**
 * Sub-route suffixes (relative to /patient/:id) that show `PatientProfileHeader`.
 *
 * Two readers, one list: the patient route renders the header from it, and the
 * layout's page-title row hides itself from it — the header already names the
 * patient (`#123`, name, age/sex, state), so the title above it would say the
 * same thing a second time. Keeping both off one constant is the point; a second
 * list of routes would drift.
 */
const HEADER_SUFFIXES = [
  "",
  "/measurements",
  "/alerts",
  "/alerts/thresholds",
  "/raw/lvfp",
  "/raw/dri",
  "/raw/afib",
  "/raw/vitals",
  "/raw/symptoms",
  "/events",
];

/** Whether `PatientProfileHeader` renders on this pathname. */
export function patientProfileHeaderVisible(pathname: string): boolean {
  return HEADER_SUFFIXES.some(
    (suffix) =>
      matchPath({ path: `/patient/:id${suffix}`, end: true }, pathname) !==
      null,
  );
}
